// Per runbook PR 10: one QueryClient per build (visitor + staff each
// get their own; the legacy CRA at frontend/src/ uses one too). Factory
// returns a fresh instance so apps can construct + own the client.

import { QueryClient } from "@tanstack/react-query";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
}
